import { generateTestId } from "@client-shared";

export const setProductsTableTestId = (identifier: string): string =>
  generateTestId("ProductsTable", identifier);
